// extracted by mini-css-extract-plugin
export var actionButton = "_jf-t";
export var buttonContainer = "_jf-0";
export var buttonContainer2 = "_jf-1";
export var buttonSection = "_jf-2";
export var details = "_jf-3";
export var dropdownItem = "_jf-5";
export var dropdownItemsContainer = "_jf-4";
export var fileInput = "_jf-r";
export var headerButton = "_jf-6";
export var icon = "_jf-7";
export var input = "_jf-8";
export var macroListItem = "_jf-9";
export var mainContent = "_jf-a";
export var microText = "_jf-b";
export var modal = "_jf-w";
export var optionsButton = "_jf-c";
export var paperclip = "_jf-s";
export var pillContent = "_jf-d";
export var preview = "_jf-e";
export var preview2 = "_jf-f";
export var quillEditor = "_jf-q";
export var selectedMacro = "_jf-g";
export var sidebar = "_jf-h";
export var sidebarHeader = "_jf-j";
export var sidebarList = "_jf-i";
export var sidebarListItem = "_jf-k";
export var sidebarSearch = "_jf-l";
export var snoozeDurationWrapper = "_jf-v";
export var statusPillContainer = "_jf-m";
export var tagsContainer = "_jf-n";
export var unselectedMacro = "_jf-o";
export var variable = "_jf-u";
export var wrapper = "_jf-p";